
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emergency-management",
      function () {
        return require("private-next-pages/emergency-management.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emergency-management"])
      });
    }
  